<template>
  <svg preserveAspectRatio="xMidYMax slice" viewBox="0 0 1920 1080" id="canvas"></svg>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import formatter from './formatter.mixin.js';

export default {
  name: 'elevators-map',
  props: [
    'template',
    'elevators'
  ],
  mixins: [formatter],
  mounted() {
    var canvas = this.$svg.get('#canvas').size('100%','100%');


    canvas.svg(this.template);

    for(var i = 0; i < this.elevators.length; i++) {
      var elevator = this.elevators[i];

      var hide = this.$svg.get('#' + elevator.map_id + '-hide');
      if(hide != null) {
        console.log(hide);
        hide.node.style.opacity = 1;
        hide.linkTo('/#/lifts/' + elevator.id);
      } else {
        console.log(elevator.map_id + " not found");
        continue
      }

      var pos = this.$svg.get('#' + elevator.map_id + '-position');
      if(pos != null) {
        pos.node.textContent = elevator.position;
      }

      var st = this.$svg.get('#' + elevator.map_id + '-status-text');
      if(st != null) {
        st.node.textContent = this.nameForStatus(elevator.status);
      }

      var tum = this.$svg.get('#' + elevator.map_id + '-tum');
      if(tum != null) {
        tum.node.textContent = elevator.stopsUntilService;
      }

      //var img = this.$svg.get('#' + elevator.map_id + '-status-image');

      var c = this.classForElevator(elevator);

      var bg = this.$svg.get('#' + elevator.map_id + '-status-color');
      if(bg != null) {
        if (c != 'operational-online') {
          bg.attr('style', '');
          bg.attr('class', c);
        }
      }
    }
  },
  beforeDestroy() {
  },
  methods: {
    elevatorsInGroupWithStatus: function(group, status) {
      return group.elevators.filter(e => e.status == status);
    },
  },
}
</script>

<style>
  .lifts {
    opacity: 0.25;
  }
  .operational-online {
    fill: #00cc33;
    background-color: #00cc33;
  }
</style>



// WEBPACK FOOTER //
// src/ElevatorsMap.vue